// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__20ZVa","title":"AfterBackImages_title__2ZUOn","images":"AfterBackImages_images__2DZnX"};